import { useState } from "react";
import { register } from "@/services/auth";
import { Button } from "@/components/ui/Button";
import { useToast } from "@/context/ToastContext";
import { NavBar } from "@/components/layout/NavBar";

export default function RegisterPage() {
  const { show: showToast } = useToast();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, username, password);
      setDone(true);
    } catch (err: any) {
      showToast("error", err.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  }

  if (done) {
    return (
      <div className="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-100">
        <NavBar />
        <div className="max-w-sm mx-auto pt-20 px-6 pb-12">
          <h1 className="text-2xl font-bold mb-4 text-slate-900 dark:text-slate-100">
            Check your inbox
          </h1>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            We sent a verification link to <strong>{email}</strong>. Click it to
            activate your account, then{" "}
            <a href="/login" className="text-accent hover:text-accent-hover">
              sign in
            </a>
            .
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-100">
      <NavBar />
      <div className="max-w-sm mx-auto pt-20 px-6 pb-12">
        <h1 className="text-2xl font-bold mb-6 text-slate-900 dark:text-slate-100">
          Create your Jobs Bot account
        </h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="block">
            <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
              Email
            </span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 block w-full rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-colors duration-200"
            />
          </label>
          <label className="block">
            <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
              Username
            </span>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              minLength={3}
              className="mt-1 block w-full rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-colors duration-200"
            />
          </label>
          <label className="block">
            <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
              Password
            </span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              className="mt-1 block w-full rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-colors duration-200"
            />
          </label>
          <Button type="submit" variant="primary" loading={loading} className="w-full">
            Create account
          </Button>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Already have an account?{" "}
            <a href="/login" className="text-accent hover:text-accent-hover underline">
              Sign in
            </a>
          </p>
        </form>
      </div>
    </div>
  );
}
